import createSetSelectedDeparture from './setSelectedDeparture';
import { selectedDepartureVar } from '../reactiveVariables';

const setSelectedDeparture = createSetSelectedDeparture(selectedDepartureVar);

export default setSelectedDeparture;
